import { FlagExperiment } from 'src/data/FlagsApi/FlagsApi.type';
import { getUserGroupId } from 'src/general/components/Analytics/Analytics.helpers';

import { getGroupIdFromUserGroup } from '../getUserGroup';

type ABTestGroup = 'a' | 'b';

export const getGroupForExperiment = (experiment: FlagExperiment): ABTestGroup => {
  const userGroup = getUserGroupId();

  if (!userGroup) {
    return 'a';
  }

  const userGroupId = getGroupIdFromUserGroup(userGroup);

  return experiment.groups_a.findIndex((group) => group === userGroupId) >= 0 ? 'a' : 'b';
};
